
import BaseModel from "./BaseModel";
import {getDocs, limit, orderBy, query} from "firebase/firestore";

export default class EmailSignup extends BaseModel {
    static data_name = 'email_signups';

    static async saveSignup(name, email) {
        let instance = new this();
        instance.name = name;
        instance.email = email;
        instance.date = new Date();
        instance.admin_has_responded = false;
        await instance.save();
        return instance;
    }

    static async allByDate() {
        return await EmailSignup.allOrderedByDesc('date', 1000);
    }


}